import { RecurringAssignmentType } from '~/storm'

export type WeekdayDescriptor = {
    assignmentStatusProperty: keyof RecurringAssignmentType
    assignmentStatusCodeProperty: keyof RecurringAssignmentType
    assignmentRoomProperty: keyof RecurringAssignmentType
    assignmentRoomCodeProperty: keyof RecurringAssignmentType
    label: string
    abbreviation: string
}

const makeWeekday = <D extends string>(day: D, label: string, abbreviation: string) =>
    ({
        assignmentStatusProperty: `${day}_status`,
        assignmentStatusCodeProperty: `${day}_status_code`,
        assignmentRoomProperty: `${day}_room`,
        assignmentRoomCodeProperty: `${day}_room_code`,
        label,
        abbreviation,
    }) as const

export const weekdayDescriptors = [
    makeWeekday('monday', 'Mandag', 'M'),
    makeWeekday('tuesday', 'Tirsdag', 'T'),
    makeWeekday('wednesday', 'Onsdag', 'O'),
    makeWeekday('thursday', 'Torsdag', 'T'),
    makeWeekday('friday', 'Fredag', 'F'),
]
